import { gql } from "@apollo/client";

export const ACCEPT_LEGAL_POLICY = gql`
  mutation AcceptLegalPolicy($input: AcceptLegalPolicy!) {
    acceptLegalPolicy(input: $input)
  }
`;
